@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';
@import '../../constants/spacing.module.less';

.forecasting-drawer {
  text-align: left;
  max-width: 1480px;
  margin: auto;

  .drawer-body {
    flex: 1;
    overflow-y: auto;
    padding: @space-16;

    .drawer-content {
      padding: @space-0 @space-40;
      width: 100%;
    }
  }

  .drawer-footer {
    justify-content: flex-end;
    gap: @space-8;
    padding: @space-16;
    border-top: 1px solid var(--grey-300);
  }
}
